<script setup>
import LikeButtonComponent from "@/components/LikeButtonComponent.vue";
import { BookmarkIcon, BuildingOfficeIcon, EnvelopeIcon, GlobeAltIcon, MapIcon, MapPinIcon, PhoneIcon, ArrowUpRightIcon, CheckCircleIcon } from "@heroicons/vue/16/solid";
import TagComponent from "@/components/TagComponent.vue";
import RatingCardComponent from "@/components/cards/RatingCardComponent.vue";
import { useAuthStore } from "@/stores/auth";
import { useBusinessStore } from "@/stores/business";
const props = defineProps({
  business: {
    type: Object,
    default: () => {},
  }
}),
toggleBookmark = () => {
  if (useAuthStore().guest) {
  return alert('You need to be logged in to perform this action');
  }
  useBusinessStore().toggleBookmark(props.business.id);
},
getServicesObject = () => {
  const total = props.business?.services?.length,
      startGridOne = 0,
      startGridTwo = Math.round(total / 2),
      gridOne = props.business?.services?.slice(startGridOne, startGridTwo),
      gridTwo = props.business?.services?.slice(startGridTwo, total);

  console.log(total, startGridOne, startGridTwo, gridOne, gridTwo)
  return {
    first: gridOne,
    second: gridTwo,
  }
};
</script>

<template>
  <div>
    <div class="bg-white rounded-xl ay-shadow shadow grid grid-cols-5 mb-4 p-6">
      <div class="col-span-5 order-0">
        <div
          class="flex flex-col md:flex-row justify-between border-b-2 border-gray-100 pb-3 mb-4"
        >
          <h2
            class="text-left text-lg md:text-xl flex-grow font-semibold drop-shadow-md text-gray-600 break-all"
          >
            {{ props.business.name }}
          </h2>
          <div class="flex justify-end space-x-1 flex-shrink">
            <div :data-id="props.business.id">
              <BookmarkIcon
                id="bookmark"
                data-toggle="tooltip"
                :title="props.business ? 'Unbookmark':'BookMark'"
                :class="['h-5 w-5 text-center cursor-pointer mr-1 text-gray-600', props.business.bookmarked ? 'text-green-500' : 'text-gray-500']"
                aria-hidden="true"
                style="cursor:pointer;"
                @click="toggleBookmark"
              />
            </div>
            <div
              data-id="{{ props.business.id }}"
            >
              <LikeButtonComponent
                :id="props.business.id"
                :count="props.business.likeCount"
                :user-has-liked="props.business.liked"
                size="h-5 w-5"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="col-span-5 order-1 pr-2">
        <div
          id="services"
          class="w-full text-left mb-4 md:mb-0 pr-4"
        >
          <h4 class="h5 text-sm md:text-lg mb-4 font-semibold text-gray-300">
            Services offered
          </h4>
          <div class="grid grid-cols-1 md:grid-cols-2">
            <div
              v-for="(services, index) in getServicesObject()"
              :key="index"
              :class="['text-sm text-gray-500 font-semibold', index === 'first' ? 'md:border-r-2 border-gray-100' : 'md:pl-4']"
            >
              <ul>
                <li
                  v-for="service in services"
                  :key="service"
                  class="mb-2 flex items-center"
                >
                  <CheckCircleIcon class="h-5 w-5 text-center text-gray-600 cursor-pointer mr-3" />
                  {{ service }}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      id="info"
      class="md:hidden bg-white rounded-xl ay-shadow shadow col-span-5 order-2 lg:order-3 border-gray-100 p-6 mb-4"
    >
      <h4 class="h5 text-sm text-left md:text-lg mb-4 font-semibold text-gray-300">
        Contact
      </h4>
      <div>
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3">
          <div class="flex flex-row md:flex-col flex-wrap justify-between md:justify-normal lg:items-start mb-4 md:mb-1">
            <span class="text-gray-300 text-xs items-center md:text-sm flex font-semibold">
              <BuildingOfficeIcon
                id="bookmark"
                data-toggle="tooltip"
                class="h-5 w-5 text-center text-gray-300 cursor-pointer mr-1"
                aria-hidden="true"
                style="cursor:pointer;"
              />
              Category
            </span>
            <TagComponent
              :title="props.business.category?.name"
              :class="`text-xs text-left lg:text-center md:mt-4 rounded-md px-1.5 py-0.5`"
              :bg-color="props.business.category?.background"
              :color="props.business.category?.color"
            />
          </div>
          <div class="flex flex-row md:flex-col flex-wrap justify-between md:justify-normal items-center mb-4 md:mb-8">
            <span class="text-gray-300 text-xs items-center md:text-sm flex font-semibold">
              <MapIcon
                id="bookmark"
                data-toggle="tooltip"
                class="h-5 w-5 text-center text-gray-300 cursor-pointer mr-1"
                aria-hidden="true"
                style="cursor:pointer;"
              />
              Location
            </span>
            <span class="block md:mt-4">
              <!--                  <a href="http://gh-top.test/chilling/restaurant-bar" class="text-muted">-->
              <span class="text-gray-500 font-medium text-sm">
                {{ props.business.region?.name }}
              </span>
              <!--                  </a>-->
            </span>
          </div>
          <div class="flex flex-row md:flex-col flex-wrap justify-between md:justify-normal lg:items-end mb-4 md:mb-8">
            <span class="text-gray-300 text-xs items-center md:text-sm flex font-semibold">
              <PhoneIcon
                id="bookmark"
                data-toggle="tooltip"
                class="h-5 w-5 text-center text-gray-300 cursor-pointer mr-1"
                aria-hidden="true"
                style="cursor:pointer;"
              />
              Phone
            </span>
            <span class="block text-right md:mt-4">
              <ul>
                <li
                  v-for="(phone, index) in props.business.phone"
                  :key="index"
                >
                  <a
                    :href="`tel:${ phone }`"
                    class="text-gray-500 text-sm font-medium hover:text-red-500 dark:text-red-400 dark:hover:text-red-500"
                  >
                    <span>{{ phone }}</span>
                  </a>
                </li>
              </ul>
            </span>
          </div>
          <div class="flex flex-row md:flex-col flex-wrap justify-between md:justify-normal md:items-center lg:items-start mb-4 md:mb-1">
            <span class="text-gray-300 text-xs items-center md:text-sm flex font-semibold">
              <EnvelopeIcon
                id="bookmark"
                data-toggle="tooltip"
                class="h-5 w-5 text-center text-gray-300 cursor-pointer mr-1"
                aria-hidden="true"
                style="cursor:pointer;"
              />
              E-mail
            </span>
            <span class="md:mt-4 block break-all">
              <a
                :href="`mailto:${ props.business.email }`"
                class="text-gray-500 text-sm font-medium"
              >
                <span class="">{{ props.business.email }}</span>
              </a>
            </span>
          </div>
          <div class="flex flex-row md:flex-col flex-wrap justify-between md:justify-normal lg:items-center mb-4 md:mb-1">
            <span class="text-gray-300 text-xs items-center md:text-sm flex font-semibold">
              <GlobeAltIcon
                id="bookmark"
                data-toggle="tooltip"
                class="h-5 w-5 text-center text-gray-300 cursor-pointer mr-1"
                aria-hidden="true"
                style="cursor:pointer;"
              />
              Website
            </span>
            <span
              class="md:mt-4 inline-flex"
              data-toggle="tooltip"
              π
              title="Go to website"
            >
              <a
                :href="`${ props.business.url }`"
                class="text-sm hover:text-green-600 transition-all duration-700 text-gray-500 font-medium"
                target="_blank"
              >
                <span class="flex items-center">
                  {{ 'Visite' }}
                  <ArrowUpRightIcon
                    class="h-5 w-5 text-green-700"
                  />
                </span>
              </a>
            </span>
          </div>
          <div
            class="flex flex-row md:flex-col flex-wrap justify-between md:justify-center md:items-center lg:items-end md:text-center"
          >
            <span
              class="text-gray-300 text-xs items-center md:text-sm flex font-semibold md:justify-center"
            >
              <MapPinIcon
                id="bookmark"
                data-toggle="tooltip"
                class="h-5 w-5 text-center text-gray-300 cursor-pointer mr-1"
                aria-hidden="true"
                style="cursor:pointer;"
              />
              Address
            </span>
            <span class="md:mt-4 block break-all text-right">
              <!--                  <a href="http://gh-top.test/chilling/restaurant-bar" class="text-muted">-->
              <span class="text-gray-500 font-medium text-sm">
                {{ props.business.city?.name }} - {{ props.business.address }}
              </span>
              <!--                  </a>-->
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="bg-white rounded-xl ay-shadow shadow p-6 text-left">
      <div
        id="description"
      >
        <div>
          <h3 class="mb-4 font-semibold text-lg text-gray-300 inline-block pb-0.5">
            About
          </h3>
          <div
            class="text-gray-500 text-base font-medium"
            v-html="props.business.description"
          />
        </div>
      </div>
    </div>
    <div class="w-full text-right mb-4 self-center">
      <span class="text-gray-400 text-sm block py-2 px-4">last updated
        {{ props.business.updatedAt }}</span>
    </div>
  </div>
</template>

<style scoped></style>
